/* pdp.js — buy-box interactions for pdp-hero (loaded with defer). */
(function () {
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* Refresh inline-cart contract: POST /cart/add.js with JSON items, then
     toggle .active on .inline-cart — its MutationObserver re-renders the cart
     and updates the header count. Falls back to /cart if the inline cart is absent. */
  function openInlineCart() {
    var cart = document.querySelector('.inline-cart');
    if (!cart) { window.location = '/cart'; return; }
    var overlay = document.querySelector('.inline-cart__page-overlay');
    cart.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('body--no-scroll');
  }

  /* XMLHttpRequest on purpose, not fetch. Appstle's storefront script wraps
     window.fetch and rewrites the selling_plan on /cart/add.js for the product
     being viewed to match its own widget's selection — which this theme does not
     render, so every Subscribe & Save add was silently landing as a one-time
     purchase (and merging into the one-time line). XHR bypasses that wrapper and
     the plan reaches Shopify intact. The 3-for-2 widget (pdp-3for2.js) watches
     fetch for cart mutations, so a cart:updated event is dispatched here instead. */
  function ajaxAddToCart(items) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        var data;
        try { data = JSON.parse(xhr.responseText); } catch (e) { data = {}; }
        if (xhr.status < 200 || xhr.status >= 300) { reject(data); return; }
        document.dispatchEvent(new Event('cart:updated'));
        resolve(data);
      };
      xhr.onerror = function () { reject({ message: 'Network error' }); };
      xhr.send(JSON.stringify({ items: items }));
    });
  }

  function initHero(hero) {
    if (hero.dataset.pdpInit) return;
    hero.dataset.pdpInit = '1';

    var onePrice = parseInt(hero.dataset.onePrice, 10) || 0;
    var subPrice = parseInt(hero.dataset.subPrice, 10) || onePrice;
    var freeShip = parseInt(hero.dataset.freeShip, 10) || 0;
    // Prefer the cart's per-country threshold (snippets/free-shipping-config
    // via window.cartData) so this bar can't drift from the cart bar; the
    // section setting is only a fallback. Same contract as the UK theme.
    if (window.cartData && window.cartData.freeShippingPossible === 'true') {
      var cartThreshold = Number(window.cartData.freeShippingThreshold) * 100;
      if (cartThreshold > 0) freeShip = cartThreshold;
    }
    var planId = hero.dataset.sellingPlan || '';

    var qtyInput = hero.querySelector('.pdp-qty__input');
    var planInput = hero.querySelector('[data-pdp-selling-plan-input]');
    var opts = hero.querySelectorAll('[data-pdp-opt]');
    var atcPrice = hero.querySelector('[data-pdp-atc-price]');
    var stickyPrice = hero.querySelector('[data-pdp-sticky-price]');
    var guarPrice = document.querySelector('[data-pdp-guar-price]');
    var guarAdd = document.querySelector('[data-pdp-guar-add]');

    function isSub() {
      var sel = hero.querySelector('[data-pdp-opt].is-selected');
      return sel && sel.getAttribute('data-pdp-opt') === 'subscribe';
    }
    function unit() { return isSub() ? subPrice : onePrice; }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function refresh() {
      var total = unit() * qty();
      if (atcPrice) atcPrice.textContent = money(total);
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (guarPrice) guarPrice.textContent = money(total);
      if (planInput) planInput.value = isSub() ? planId : '';
      var shipMsg = hero.querySelector('[data-pdp-ship-msg]');
      var shipCount = hero.querySelector('[data-pdp-ship-count]');
      var shipFill = hero.querySelector('[data-pdp-ship-fill]');
      if (freeShip > 0 && shipFill) {
        // The $40 threshold applies to subscriptions too (changed 2026-10-09;
        // the "Free Delivery For SNS" profile now mirrors the General profile).
        var pct = Math.min((total / freeShip) * 100, 100);
        shipFill.style.width = pct + '%';
        if (shipCount) shipCount.textContent = money(total) + ' / ' + money(freeShip);
        if (shipMsg) {
          if (total >= freeShip) { shipMsg.innerHTML = '<strong>Free shipping unlocked</strong>'; }
          else { shipMsg.innerHTML = '<strong>Spend</strong> ' + money(freeShip - total) + ' <strong>more for free shipping</strong>'; }
        }
      }
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('is-selected'); var r = o.querySelector('input[type=radio]'); if (r) r.checked = false; });
        opt.classList.add('is-selected');
        var r = opt.querySelector('input[type=radio]'); if (r) r.checked = true;
        refresh();
      });
    });

    hero.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = qty();
        v = btn.getAttribute('data-pdp-qty') === 'up' ? v + 1 : Math.max(1, v - 1);
        if (qtyInput) qtyInput.value = v;
        refresh();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', refresh);

    var stages = hero.querySelectorAll('[data-pdp-stage]');
    var thumbs = hero.querySelectorAll('[data-pdp-thumb]');
    var stageWrap = hero.querySelector('.pdp-hero__stage');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-pdp-thumb');
        stages.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-pdp-stage') === i); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        // overlay badges (formula pill, origin logo) belong to the pack shot only
        if (stageWrap) stageWrap.classList.toggle('is-alt-image', i !== '0');
      });
    });

    var crossTrack = hero.querySelector('.pdp-cross__track');
    var dots = hero.querySelectorAll('[data-pdp-cross-dot]');
    if (crossTrack && dots.length) {
      var setDot = function (i) {
        dots.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
      };
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.getAttribute('data-pdp-cross-dot'), 10);
          crossTrack.scrollTo({ left: i * crossTrack.clientWidth, behavior: 'smooth' });
          setDot(i);
        });
      });
      var crossScrollT;
      crossTrack.addEventListener('scroll', function () {
        clearTimeout(crossScrollT);
        crossScrollT = setTimeout(function () {
          setDot(Math.round(crossTrack.scrollLeft / crossTrack.clientWidth));
        }, 80);
      }, { passive: true });
    }

    hero.querySelectorAll('.pdp-acc__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        var open = btn.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      });
    });

    var sticky = hero.querySelector('[data-pdp-sticky]');
    var buyBox = hero.querySelector('.pdp-hero__buy');
    var mainForm = hero.querySelector('.pdp-hero__pform');
    var stickyAdd = hero.querySelector('[data-pdp-sticky-add]');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; });
      }, { rootMargin: '0px 0px -80% 0px' });
      io.observe(buyBox);
    }
    if (stickyAdd && mainForm && !stickyAdd.hasAttribute('disabled')) {
      stickyAdd.addEventListener('click', function () {
        if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.querySelector('[name=add]').click();
      });
    }

    var heroAtc = hero.querySelector('.pdp-hero__atc');
    if (guarAdd && mainForm) {
      if (heroAtc && heroAtc.hasAttribute('disabled')) {
        guarAdd.setAttribute('disabled', '');
      } else {
        guarAdd.addEventListener('click', function () {
          if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.querySelector('[name=add]').click();
        });
      }
    }

    // Add to cart — intercept the Dawn form and use the inline-cart contract instead.
    // (Sticky ATC and the guarantee button submit this same form, so they route here too.)
    var errWrap = hero.querySelector('.product-form__error-message-wrapper');
    var errMsg = hero.querySelector('.product-form__error-message');
    if (mainForm) {
      mainForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = mainForm.querySelector('input[name="id"]');
        if (!idInput || idInput.disabled) return;
        var item = { id: parseInt(idInput.value, 10), quantity: qty() };
        if (planInput && planInput.value) item.selling_plan = parseInt(planInput.value, 10);
        var btn = mainForm.querySelector('[name="add"]');
        if (btn) btn.setAttribute('disabled', '');
        if (errWrap) errWrap.hidden = true;
        ajaxAddToCart([item])
          .then(function () { openInlineCart(); })
          .catch(function (err) {
            var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
            if (errMsg && errWrap) { errMsg.textContent = msg; errWrap.hidden = false; }
          })
          .then(function () { if (btn) btn.removeAttribute('disabled'); });
      });
    }

    // Cross-sell "ADD +" forms — same contract, quantity 1.
    hero.querySelectorAll('.pdp-cross__pform').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = f.querySelector('input[name="id"]');
        if (!idInput) return;
        var btn = f.querySelector('[name="add"]');
        if (btn) btn.setAttribute('disabled', '');
        ajaxAddToCart([{ id: parseInt(idInput.value, 10), quantity: 1 }])
          .then(function () { openInlineCart(); })
          .catch(function () {})
          .then(function () { if (btn) btn.removeAttribute('disabled'); });
      });
    });

    refresh();
  }

  function initScrollbars() {
    document.querySelectorAll('[data-pdp-scroll]').forEach(function (sc) {
      var bar = sc.parentElement.querySelector('.pdp-scrollbar');
      if (!bar) return;
      var thumb = bar.querySelector('.pdp-scrollbar__thumb');
      function update() {
        var ratio = sc.clientWidth / sc.scrollWidth;
        if (ratio >= 0.995) { bar.classList.remove('is-visible'); return; }
        bar.classList.add('is-visible');
        thumb.style.width = (ratio * 100) + '%';
        var max = sc.scrollWidth - sc.clientWidth;
        var p = max > 0 ? sc.scrollLeft / max : 0;
        thumb.style.transform = 'translateX(' + (p * (100 / ratio - 100)) + '%)';
      }
      sc.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  function init() { document.querySelectorAll('[data-pdp-hero]').forEach(initHero); initScrollbars(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
